import { Inngest } from 'inngest'

export const inngest = new Inngest({ id: 'ask-qien' })

/** Fired when a line manager submits a ticket or re-submits clarification info. */
export type TicketSubmittedEvent = {
  name: 'ticket/submitted'
  data: {
    ticketId: string
    tenantId: string
    messageId: string
    ticketVersion: number
  }
}

/** Fired after completeness passes and Hook 4 should create the expert summary. */
export type TicketTriagedEvent = {
  name: 'ticket/triaged'
  data: {
    ticketId: string
    tenantId: string
    messageId: string
    ticketVersion: number
  }
}

/** Fired when a knowledge entry needs its markdown embedded for semantic search. */
export type KnowledgeEntryChangedEvent = {
  name: 'knowledge/entry.changed'
  data: {
    entryId: string
    tenantId: string
    action: 'created' | 'updated'
  }
}

/** Fired when an expert requests a KB-grounded response draft. */
export type TicketResponseDraftRequestedEvent = {
  name: 'ticket/response_draft.requested'
  data: {
    ticketId: string
    tenantId: string
    expertId: string | null
    ticketVersion: number
  }
}

/** Fired after an expert sends a response, allowing Hook 6 to propose KB updates. */
export type TicketRespondedEvent = {
  name: 'ticket/responded'
  data: {
    ticketId: string
    tenantId: string
    expertId: string
    responseMessageId: string
  }
}

export type Events = {
  'ticket/submitted': TicketSubmittedEvent
  'ticket/triaged': TicketTriagedEvent
  'knowledge/entry.changed': KnowledgeEntryChangedEvent
  'ticket/response_draft.requested': TicketResponseDraftRequestedEvent
  'ticket/responded': TicketRespondedEvent
}
